exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".desc-wrap .desc[data-v-22a4755a]{position:relative;margin-top:.1rem;width:100%;font-size:16px;font-family:'RobotoRegular';font-weight:normal;color:#999;line-height:.38rem}\n", ""]);

